import { UnleashClient } from 'unleash-proxy-client';

const config = {
  url: process.env.APP_UNLEASH_URL as string,
  clientKey: process.env.APP_UNLEASH_KEY as string,
  refreshInterval: Number(process.env.APP_UNLEASH_REFRESH_INTERVAL),
  appName: 'LifeBase', // required but not used, used like env in gitLab
  environment: process.env.APP_ENV || 'develop',
};

const unleashClient = new UnleashClient(config);

export { unleashClient };
